import api from '../token';

export const ListParceiro = async () => {
  try {
    const response = await api.post('/getParceiro');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

